import React from "react";
import * as s from "./datatable.module.css";

import { Button, Checkbox } from "../index";

import { KeyValue } from "../../types/subTypes";

interface DataTableProps {
  title?: string;
  titles?: string[];
  columns: KeyValue[];
  uniqueColumn?: KeyValue;
  items: {
    [key: string]: any;
  }[];
  showCheckBox?: boolean;
  isChecked?: any;
  changeCheckBox?: any;
  rowButtonText?: string;
  rowButtonAction?: any;
  headerButtonContent?: any;
  headerButtonAction?: any;
}

const DataTable: React.FC<DataTableProps> = ({
  title,
  titles,
  columns,
  uniqueColumn,
  items,
  showCheckBox,
  isChecked,
  changeCheckBox,
  rowButtonText,
  rowButtonAction,
  headerButtonContent,
  headerButtonAction,
}) => {
  return (
    <>
      <div className="card border border-primary">
        <div className="card-header bg-primary border border-primary py-3">
          <h5 className="card-title fw-bold text-white m-0">
            {title && <span className={s.title}>{title}</span>}
          </h5>
        </div>
        <div className="card-body p-0 pb-3">
          {titles && (
            <div className={"border-bottom " + `${s.headerLight}`}>
              {showCheckBox && (
                <div
                  className={s.cell}
                  style={{ maxWidth: "5%", marginRight: 15 }}
                />
              )}

              <div
                className={s.cell}
                style={{ maxWidth: "10%", marginRight: 15 }}
              />

              {titles.map((title) => (
                <div key={title} className={s.cell}>
                  <span className={s.titleLight}>{title}</span>
                </div>
              ))}
            </div>
          )}

          <div className={s.dataTable}>
            <div className={s.dataTableHead}>
              {showCheckBox && (
                <div
                  className={s.cell}
                  style={{ maxWidth: "5%", marginRight: 15 }}
                />
              )}

              {uniqueColumn && (
                <div className={s.cell}>
                  <span className={s.column}>{uniqueColumn.value}</span>
                </div>
              )}

              {columns.map((column) => (
                <div key={column.key} className={s.cell}>
                  <span className={s.column}>{column.value}</span>
                </div>
              ))}

              {rowButtonText && (
                <div className={s.cell} style={{ maxWidth: "10%" }} />
              )}
            </div>

            <div className={s.dataTableBody}>
              {items.map(
                (row, index) =>
                  row[columns[0].key] && (
                    <div
                      key={index}
                      className={s.row}
                      style={{
                        backgroundColor: index % 2 === 0 ? "#F7F7FA" : "#FFF",
                      }}
                    >
                      {showCheckBox && (
                        <div
                          className={s.cell}
                          style={{ maxWidth: "5%", marginRight: 15 }}
                        >
                          <Checkbox
                            checked={isChecked && isChecked(row)}
                            onChange={() =>
                              changeCheckBox && changeCheckBox(row)
                            }
                          />
                        </div>
                      )}

                      {uniqueColumn && (
                        <div className={s.cell}>
                          <span className={s.value}>
                            {row[uniqueColumn.key]}
                          </span>
                        </div>
                      )}

                      {columns.map((column) => (
                        <div key={column.key} className={s.cell}>
                          <span className={s.value}>{row[column.key]}</span>
                        </div>
                      ))}

                      {rowButtonText && (
                        <div className={s.cell} style={{ maxWidth: "10%" }}>
                          <Button
                            type="button"
                            content={rowButtonText}
                            onClick={() =>
                              rowButtonAction ? rowButtonAction(row) : {}
                            }
                          />
                        </div>
                      )}
                    </div>
                  )
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export { DataTable };
